import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 py-12",
  style: {"font-family":"PlexRegular"}
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl pb-16" }
const _hoisted_3 = {
  class: "font-bold text-gray-800 mb-4 text-2xl text-center pb-2 uppercase",
  style: {"color":"rgb(41 57 152)","font-family":"PlexSemiBold"}
}
const _hoisted_4 = {
  key: 0,
  class: "text-center pb-5"
}
const _hoisted_5 = { class: "text-lg font-semibold text-gray-600 mb-1" }
const _hoisted_6 = { class: "text-md text-gray-500" }
const _hoisted_7 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_8 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_13 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_16 = { class: "text-sm text-red-500 p-error" }
const _hoisted_17 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_18 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-sm text-red-500 p-error" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_31 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_32 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_33 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_38 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_39 = { class: "text-sm text-red-500 p-error" }
const _hoisted_40 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_41 = { class: "text-sm text-red-500 p-error" }
const _hoisted_42 = { class: "flex flex-wrap py-2 mt-6" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_45 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.franjaSeleccionada ? _ctx.franjaSeleccionada.descripcionExtra1 : ''), 1),
            (_ctx.franjaSeleccionada)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.descripcionTurno) + " " + _toDisplayString(_ctx.franjaSeleccionada.franjaHoraria), 1),
                  _createElementVNode("p", _hoisted_6, "Sala : " + _toDisplayString(_ctx.franjaSeleccionada.descripcionExtra2), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su nombre",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su apellido",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "DNI", -1)),
                _createVNode(_component_Field, {
                  name: "documento",
                  modelValue: _ctx.formData.documento,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.documento) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su DNI",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "documento" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "Email", -1)),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su email",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "País de residencia", -1)),
                _createVNode(_component_Field, {
                  name: "pais",
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCountry) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      filter: "",
                      options: _ctx.paises,
                      optionLabel: "value",
                      placeholder: "Seleccione un País",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "pais" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                (_ctx.selectedCountry?.value === 'Argentina')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_Field, {
                        name: "provinciaSelect",
                        modelValue: _ctx.formData.provinciaSelect,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.provinciaSelect) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            filter: "",
                            placeholder: "Seleccione la provincia",
                            options: _ctx.provincias,
                            optionLabel: "descripcion",
                            class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                          _createElementVNode("span", _hoisted_22, [
                            _createVNode(_component_ErrorMessage, { name: "provinciaSelect" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_Field, {
                        name: "provinciaInput",
                        modelValue: _ctx.formData.provinciaInput,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.provinciaInput) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Ingrese su provincia/estado",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_24, [
                            _createVNode(_component_ErrorMessage, { name: "provinciaInput" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "Ciudad / Localidad", -1)),
                (_ctx.selectedCountry?.value === 'Argentina')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createVNode(_component_Field, {
                        name: "localidadSelect",
                        modelValue: _ctx.formData.localidadSelect,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.localidadSelect) = $event))
                      }, {
                        default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                          _createVNode(_component_Select, {
                            onBlur: handleBlur,
                            "onUpdate:modelValue": handleChange,
                            "model-value": value,
                            filter: "",
                            placeholder: "Seleccione la localidad",
                            options: _ctx.localidades,
                            optionLabel: "descripcion",
                            class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                          }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                          _createElementVNode("span", _hoisted_27, [
                            _createVNode(_component_ErrorMessage, { name: "localidadSelect" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createVNode(_component_Field, {
                        name: "ciudadInput",
                        modelValue: _ctx.formData.ciudadInput,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.ciudadInput) = $event))
                      }, {
                        default: _withCtx(({ field, errors }) => [
                          _createVNode(_component_InputText, _mergeProps(field, {
                            type: "text",
                            placeholder: "Ingrese su ciudad/localidad",
                            class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                          }), null, 16, ["class"]),
                          _createElementVNode("span", _hoisted_29, [
                            _createVNode(_component_ErrorMessage, { name: "ciudadInput" })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "País", -1)),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedPhoneCountry,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedPhoneCountry) = $event)),
                  filter: "",
                  options: _ctx.paises,
                  optionLabel: "value",
                  placeholder: "Seleccione un País",
                  class: "input-base"
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)),
                _createVNode(_component_InputText, {
                  type: "text",
                  "model-value": _ctx.selectedPhoneCountry ? _ctx.selectedPhoneCountry.code : '',
                  class: "input-base",
                  readonly: ""
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cód. Área (sin 0)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_34, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)),
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Celular (sin 15)",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-1" }, "Nacionalidad", -1)),
                _createVNode(_component_Field, {
                  name: "nacionalidad",
                  modelValue: _ctx.formData.nacionalidad,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.nacionalidad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su nacionalidad",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_39, [
                      _createVNode(_component_ErrorMessage, { name: "nacionalidad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1" }, "Profesión", -1)),
                _createVNode(_component_Field, {
                  name: "rubro",
                  modelValue: _ctx.formData.rubro,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.rubro) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      options: _ctx.rubros,
                      optionLabel: "descripcion",
                      class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value, 'input-error': errors.length > 0 }])
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_41, [
                      _createVNode(_component_ErrorMessage, { name: "rubro" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                type: "submit",
                class: "px-6 py-3 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded-lg cursor-pointer transition-colors duration-350",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_44, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_45, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _cache[27] || (_cache[27] = _createTextVNode("ACEPTAR "))
              ], 8, _hoisted_43)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"]),
      _createVNode(_component_BlockUI, {
        blocked: _ctx.isSubmitting,
        fullScreen: ""
      }, null, 8, ["blocked"])
    ])
  ], 64))
}